module.exports = __webpack_public_path__ + "static/media/background.21d42609.png";